import { IProperty } from "../../../../../shared/interfaces/IProperties";
import { Divisor } from "../../../bci/styles";

interface Props {
    propertyInfo?: IProperty;
}

export const StandardUsoSolo: React.FC<Props> = ({ propertyInfo }) => {
    const permit = propertyInfo?.zoneamento?.lei_permitidas;
    const permitidas = permit?.replace(/(<([^>]+)>)/gi, "");
    const permis = propertyInfo?.zoneamento?.lei_permissivas;
    const permissivas = permis?.replace(/(<([^>]+)>)/gi, "");
    const probid = propertyInfo?.zoneamento?.lei_proibidas;
    const proibidas = probid?.replace(/(<([^>]+)>)/gi, "");
    return (
        <>
            <br />
            <Divisor />
            <div className="text-center">
                <h3>
                    PARÂMETROS DE USO DO SOLO - Anexo V da Lei Complementar
                    n°--/----
                </h3>
                <br />
                <table className="w-full table-auto">
                    <thead className="border-t">
                        <tr className="bg-gray-200 border">
                            <th className="border px-4 py-2">
                                LEIS PERMITIDAS
                            </th>
                            <th className="border px-4 py-2">
                                LEIS PERMISSIVAS
                            </th>
                            <th className="border px-4 py-2">LEIS PROIBIDAS</th>
                        </tr>
                    </thead>
                    <tbody className="border">
                        <tr>
                            <td
                                className="whitespace-pre-line border px-4 py-2"
                                align="center"
                            >
                                {permitidas}
                            </td>
                            <td
                                className="whitespace-pre-line border px-4 py-2"
                                align="center"
                            >
                                {permissivas}
                            </td>
                            <td
                                className="whitespace-pre-line border px-4 py-2"
                                align="center"
                            >
                                {proibidas}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <br />
            <Divisor />
        </>
    );
};
